module.exports = __webpack_public_path__ + "static/img/4017.cad8eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4017.png
// module id = 724
// module chunks = 0 1 12